import React from "react";

import * as S from "./styled";

const VectorIcon = () => (
  <S.IconWrapper
    fill="none"
    focusable="false"
    height="9"
    viewBox="0 0 13 9"
    width="13"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.125 7.5H2V0.375C2 0.167812 1.83219 0 1.625 0H0.875C0.667812 0 0.5 0.167812 0.5 0.375V8.25C0.5 8.66414 0.835859 9 1.25 9H12.125C12.3322 9 12.5 8.83219 12.5 8.625V7.875C12.5 7.66781 12.3322 7.5 12.125 7.5ZM11.375 0.75H8.60797C8.10688 0.75 7.85586 1.35586 8.21023 1.71023L8.96961 2.46961L7.25 4.18945L5.53039 2.46984C5.23742 2.17688 4.76258 2.17688 4.46984 2.46984L2.85992 4.07977C2.71344 4.22625 2.71344 4.46367 2.85992 4.61016L3.39008 5.14031C3.53656 5.2868 3.77398 5.2868 3.92047 5.14031L5 4.06055L6.71961 5.78016C7.01258 6.07312 7.48742 6.07312 7.78016 5.78016L10.0302 3.53016L10.7895 4.28953C11.1439 4.64391 11.7498 4.39289 11.7498 3.8918V1.125C11.75 0.917812 11.5822 0.75 11.375 0.75Z"
      fill="#164DB4"
    />
  </S.IconWrapper>
);

export default VectorIcon;
